<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <b-button
            :title="$t('Cadastrar Técnico')"
            @click.prevent="$parent.page = 'tecnicos_add'"
            type="button"
            v-b-tooltip.hover
            variant="primary"
          >
            <i class="fas fa-plus-square" />
            {{ $t("Cadastrar") }}
          </b-button>

          <div>
            <div class="input-group mb-3">
              <b-input
                :placeholder="$t('Type to search')"
                class="form-control search-input"
                type="text"
                v-model="search"
                v-on:change="getTecnicos"
                aria-describedby="input-search"
              />
              <div class="input-group-append" role="button">
                <span class="input-group-text" id="input-search"
                  ><i class="fas fa-search search-icon"
                /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
        <b-table
          :fields="[
            {
              key: 'nome',
              label: $t('Nome'),
            },
            {
              key: 'email',
              label: $t('E-mail'),
            },
            {
              key: 'role',
              label: $t('Role'),
            },
            {
              key: 'status',
              label: $t('Status'),
            },
            {
              key: 'actions',
              label: '',
              class: 'text-right',
            },
          ]"
          :items="tecnicosList"
          :responsive="true"
          striped
          hover
          stacked="md"
          show-empty
          small
          outlined
          table-class="mb-3"
        >
          <template v-slot:cell(nome)="data">
            {{ data.item.nome }}
          </template>
          <template v-slot:cell(email)="data">
            {{ data.item.email }}
          </template>
          <template v-slot:cell(role)="data">
            {{ data.item.role.value }}
          </template>
          <template v-slot:cell(status)="data">
            <span v-html="data.item.status_nome"></span>
          </template>
          <template v-slot:cell()="data">
            <b-button
              :title="$t('Editar Técnico')"
              @click.prevent="editTecnico(data.item.id)"
              class="px-2 mb-0"
              size="xs"
              type="button"
              v-b-tooltip.hover
              variant="success"
            >
              <i class="mdi mdi-square-edit-outline" />
            </b-button>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getTecnicos()"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }} {{ pagination.currentPage }}
              {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TecnicosUnidades",
  data() {
    return {
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      tecnicosList: [],
    };
  },
  mounted() {
    this.getTecnicos();
  },
  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getTecnicos();
      }
    },
    getTecnicos() {
      this.loading = true;
      axios
        .get("api/dashboard/tecnicos", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            unidade_id: this.$route.params.id,
          },
        })
        .then((response) => {
          this.tecnicosList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getTecnicos();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteTecnico(id) {
      swal
        .fire({
          title: this.$t("Are you sure?"),
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: this.$t("Delete"),
          icon: "warning",
        })
        .then((value) => {
          if (value) {
            this.loading = true;
            axios
              .delete("api/dashboard/tecnicos/" + id)
              .then((response) => {
                this.getTecnicos();
                this.$snack.success({
                  button: false,
                  text: response.data.data.message,
                });
              })
              .catch(() => {
                this.loading = false;
              });
          }
        });
    },
    editTecnico(value) {
      this.$parent.page = "tecnicos_edit";
      this.$parent.tecnico_id = value;
    },
  },
};
</script>
